import classNames from 'classnames'
import { debounce } from 'lodash'
import React, { useRef, useMemo, MutableRefObject } from 'react'
import { Button } from '../Button'
import { Icon } from '../Icon'
import * as styles from './styles'

export type ColorInputProps = {
  className?: string
  debounceWaitTime?: number
  /**
   * Should only be included if clicking the input will be
   * managed from parent component
   */
  externalRef?: MutableRefObject<HTMLInputElement | null>
  onInputColor: (value: string) => void
  /** Hex string with # */
  value?: string
}

export const ColorInput: React.FC<ColorInputProps> = ({
  className,
  debounceWaitTime = 1000,
  externalRef,
  onInputColor,
  value,
}) => {
  const inputRef = useRef<HTMLInputElement | null>(null)
  const handleChangeColor = useMemo(
    () => debounce(onInputColor, debounceWaitTime),
    [onInputColor, debounceWaitTime]
  )

  return (
    <div
      className={classNames(['lapidary-color-input', className])}
      css={styles.wrapper}
    >
      <Button
        name="Add Color"
        className="lapidary-add-color-button"
        css={styles.button}
        icon={<Icon glyph="gem-add" />}
        onClick={() => !externalRef && inputRef.current?.click()}
        variant="tertiary"
      />
      <input
        ref={externalRef ?? inputRef}
        css={styles.input}
        onChange={(e) => handleChangeColor(e.target.value.toUpperCase())}
        placeholder="Add color"
        type="color"
        value={value}
      />
    </div>
  )
}
ColorInput.displayName = 'Lapidary: ColorInput'
